import { System } from '@ecs/System';
import { Energy } from '@components/Energy';

export class EnergyRegenSystem extends System {
  update(deltaTime: number): void {
    const entities = this.getEntitiesWithComponents(Energy);
    
    for (const entity of entities) {
      const energy = entity.getComponent(Energy)!;
      
      // Regenerate energy over time
      if (energy.current < energy.max) {
        energy.current = Math.min(
          energy.max, 
          energy.current + energy.regenRate * (deltaTime / 1000)
        );
      }
    }
  }
}